import { render, staticRenderFns } from "./FixedButtons.vue?vue&type=template&id=b9905340&scoped=true&"
import script from "./FixedButtons.vue?vue&type=script&lang=js&"
export * from "./FixedButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9905340",
  null
  
)

export default component.exports